import React, { useRef, useEffect } from 'react'
import { drawExerciseToCanvas } from '../utils/exerciseDrawing'
import { useExerciseContext } from '../context/ExerciseContext'
import { useSettings } from '../context/SettingsContext'

interface ExerciseCanvasProps {
  currentKeyposeIndex?: number;
  width?: number;
  height?: number;
}

export const ExerciseCanvas: React.FC<ExerciseCanvasProps> = React.memo(({
  currentKeyposeIndex = 0,
  width = 400,
  height = 300,
}) => {
  const { getCurrentExercise, availableExercises, setSelectedExerciseName, shortExerciseName } = useExerciseContext()
  const selectedExercise = getCurrentExercise()
  const canvasRef = useRef<HTMLCanvasElement | null>(null)
  const { settings } = useSettings()

  // Draw exercise when selected exercise changes
  useEffect(() => {
    if (!canvasRef.current || !selectedExercise || !settings.preview_showStickFigure) {
      return
    }

    drawExerciseToCanvas(
      canvasRef.current,
      selectedExercise,
      currentKeyposeIndex,
    )
  }, [selectedExercise, currentKeyposeIndex, settings.preview_showStickFigure])

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      margin: '0px',
      borderRadius: '10px',
      overflow: 'hidden',
    }}>
      <canvas
        ref={canvasRef}
        key="exercise-canvas"
        data-canvas-type="exercise"
        width={width}
        height={height}
        style={{
          transform: 'scaleX(-1)',
          display: settings.preview_showStickFigure ? 'block' : 'none',
          borderBottom: '2px solid #333',
        }}
      />
      {shortExerciseName && (
        <div style={{ display: 'flex', userSelect: 'none' }}>
          <select style={{ width: '100%' }} onChange={(e) => setSelectedExerciseName(e.target.value)}>
            {availableExercises.map((exercise) => (
              <option key={exercise} value={exercise}>{exercise.split('_')[0]}</option>
            ))}
          </select>
        </div>
      )}
    </div>
  )
})
